import React from "react";
import { Link } from "react-router-dom";
import { Page, PageTitle, PageHeader } from "components/ui/Page";
import {
  EvenThirdsLayout,
  PageColumn,
  ColumnAtBreakpoint,
  ColumnUnlessBreakpoint,
} from "components/ui/PageColumns";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { FinancialAidHousingCard } from "../cards/FinancialAidHousingCard";
import { FinancialAidSummaryCard } from "../cards/FinancialAidSummaryCard";
import { FinancialAidAndScholarshipsProfileCard } from "components/cards/FinancialAidAndScholarshipsProfileCard";
import { FinancialAidCommunicationsCard } from "components/cards/FinancialAidCommunicationsCard";
import { CostOfAttendanceCard } from "components/cards/CostOfAttendanceCard";
import { FinancialAidAwardsCard } from "components/cards/FinancialAidAwardsCard";
import { LoanHistoryCard } from "components/cards/LoanHistoryCard";

export function FinancialAidScholarshipsPage() {
  return (
    <Page>
      <PageTitle title="Financial Aid & Scholarships" />
      <PageHeader>
        <Link to="/finances">My Finances</Link> &raquo; Financial Aid and
        Scholarships
      </PageHeader>
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <FinancialAidSummaryCard />
          <FinancialAidCommunicationsCard />
          <FinancialAidAndScholarshipsProfileCard />
        </PageColumn>
        <ColumnAtBreakpoint breakpointName="medium">
          <ColumnUnlessBreakpoint breakpointName="medium">
            <CostOfAttendanceCard />
            <FinancialAidHousingCard />
            <LoanHistoryCard />
          </ColumnUnlessBreakpoint>
          <ColumnUnlessBreakpoint breakpointName="medium">
            <FinancialAidAwardsCard />
          </ColumnUnlessBreakpoint>
        </ColumnAtBreakpoint>
      </EvenThirdsLayout>
    </Page>
  );
}
FinancialAidScholarshipsPage.displayName = "FinancialAidScholarships";
